import React from "react";
import { BrandingProvider } from "@/contexts/BrandingContext";
import { TemplateProvider } from "@/contexts/TemplateContext";
import { useTenant } from "@/contexts/TenantContext";
import { ReactNode } from "react";
import { TenantNotFound } from "@/pages/TenantNotFound";

interface TenantMarketplaceProps {
  children: ReactNode;
}

/**
 * TenantMarketplace Wrapper
 * Provides BrandingProvider and TemplateProvider for marketplace routes
 * Handles loading and error states for tenant data
 */
export const TenantMarketplace = ({ children }: TenantMarketplaceProps) => {
  const { loading, error } = useTenant();

  if (loading) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary"></div>
      </div>
    );
  }

  if (error === "TENANT_NOT_FOUND") {
    return <TenantNotFound />;
  }

  if (error) {
    return (
      <div className="min-h-screen bg-background flex items-center justify-center">
        <div className="text-center">
          <h1 className="text-2xl font-bold mb-4">Erro</h1>
          <p className="text-muted-foreground">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <BrandingProvider>
      <TemplateProvider>
        {children}
      </TemplateProvider>
    </BrandingProvider>
  );
};